<script setup>
import { useAnchorTitle } from '~/composables/useAnchorTitle'

const props = defineProps({
  title: {
    type: String,
  },
  text: {
    type: String,
  },
  slides: {
    type: Object,
  },
})

const anchorTitle = computed(() => useAnchorTitle(props.title))
</script>

<template>
  <div class="d-flex flex-column slider-stories">
    <div
      v-if="title || text"
      class="row slider-stories__content"
    >
      <div class="col-12 col-640-10 col-1200-8">
        <h2
          v-if="title"
          :id="anchorTitle"
          class="scale-4 scale-4--bold slider-stories__title"
        >
          {{ title }}
        </h2>
        <div
          v-if="text"
          class="scale-1 scale-1--lead"
        >
          <div v-html="text" />
        </div>
      </div>
    </div>
    <div class="slider-stories__slider">
      <Slider
        :show-pagination="true"
        :wrap-around="true"
        align="center"
        :slides="slides"
        class="slider--overflow slider--fade-out"
      >
        <template #default="slide">
          <SlideStory
            :slide="slide"
            class="slide__zoom"
          />
        </template>
      </Slider>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/node_modules/bootstrap/scss/mixins';

.slider-stories {
  color: $color-light;

  &__content {
    margin-bottom: 45px;

    @include media-breakpoint-down(640) {
      margin-bottom: 35px;
    }
  }

  &__title {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 10px;
  }

  &__slider {
    :deep(.embla__slide) {
      height: 550px;

      @include media-breakpoint-down(800) {
        height: 450px;
      }

      @include media-breakpoint-down(560) {
        height: 350px;
      }
    }
    :deep(.embla__slide) {
      flex: 0 0 83.333%;
    }
    @media (min-width: 576px) {
      :deep(.embla__slide) {
        flex: 0 0 62.5%;
      }
    }
    @media (min-width: 768px) {
      :deep(.embla__slide) {
        flex: 0 0 45.454545%;
      }
    }
    @media (min-width: 1200px) {
      :deep(.embla__slide) {
        flex: 0 0 27.777%;
      }
    }
  }
}

.slider-stories--rounded.slider-stories--flipped {
  .slider-stories__image {
    img {
      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;

      @include media-breakpoint-down(640) {
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
  }
}
</style>
